import { useGetWorkspacesQuery } from '@carboncopyco/data';
import { useEffect } from 'react';
import Navigation from '../components/Navigation/Navigation';
import NewCloneBody from '../components/NewCloneBody';
import useAsyncMemo from '../hooks/useAsyncMemo';
import { useUser } from '../store/context/UserContext';
import { useWorkspaces } from '../store/context/WorkspaceContext';

interface LandingPageProps {
  onNewClone: (url: string) => void;
}

export const NewCloneScreen = ({ onNewClone }: LandingPageProps) => {
  const { activeOrganization, setMe } = useUser();
  const { activeWorkspace } = useWorkspaces();
  const organizationId = activeOrganization?.id?.toString() || '';

  const { data: workspaces } = useGetWorkspacesQuery({
    organizationId,
  });

  const { data: me } = useAsyncMemo(window.dsDesktop?.me, [
    workspaces,
    activeWorkspace,
  ]);

  useEffect(() => {
    if (me) setMe(me);
  }, [me]);

  return (
    <div className="landing-page flex flex-col flex-grow flex-shrink basis-0 min-h-0">
      <Navigation showDashboardButton />
      {activeOrganization && <NewCloneBody onNewClone={onNewClone} />}
    </div>
  );
};
